<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .feature-item {
    align-items: center;
    display: flex;
    gap: 1.5rem;

    p {
      @include mixins.body1;
    }
  }
</style>

<script>
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";

  export let icon;
  export let text;
  export let subtext;
</script>

<div class="feature-item">
  <IconScale
    class={icon}
    size="large"
    backgroundColor="activityReply_5"
    color="activityReply_50"
  />
  <p><b>{text}:</b> {subtext}</p>
</div>
